
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Popover from 'vux/src/components/popover/index.vue'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import vuescroll from 'vuescroll'
import Error from '@/components/error'
import { mapState, mapActions } from 'vuex'
import { today, getRequest, DatetimeStamp } from '@/assets/scripts/utils'
export default {
name: 'home',
components: {
XHeader,
XButton,
Flow,
FlowState,
FlowLine,
Grid,
GridItem,
Badge,
Swiper,
SwiperItem,
Error,
'vueSwiper': swiper,
swiperSlide,
'scroller': vuescroll,
Confirm,
Popover
},
data () {
return {
isBadge: false,
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
swiperOption: {
speed: 400,
slidesPerView: 'auto',
spaceBetween: 20,
centeredSlides: !0,
watchSlidesProgress: !0,
parallax: true,
initialSlide: sessionStorage.getItem('swiperIndex') ? Number(sessionStorage.getItem('swiperIndex')) : 0,

on: {
slideChangeTransitionEnd: function () {
sessionStorage.setItem('swiperIndex', this.activeIndex)
}
}
},
swiper: {
index: 0,
aspectRatio: 0.63,
position: 'center'
},
userInfo: {},
flowProcedureList: [],
flowProcedureList2: [],
dataList: [],
dataList2: [],
noticeList: [],
errorMsg: {
type: 'null',
content: '暂无在线办理手续'
},
donateFlag: Boolean,
toDay: today('YYYY-MM-DD'),
wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
currentDate: ''

}
},
computed: {
title () {
return this.$route.meta.title
},
...mapState({
token: state => state.token,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo ? state.flowInfo.flowId : null,
flowType: state => state.flowInfo ? state.flowInfo.flowType : null
}),





showProcedure2 () {
return this.dataList2.filter(function (obj) {
return obj.procedureBean.flag.split('')[1] === '1'
})
},
dataFinished () {
return this.dataList.filter(function (obj) {
return obj.status === 4
})
},
dataUnfinished () {
return this.dataList.filter(function (obj) {
return obj.status !== 4
})
}
},
created () {

},
mounted () {


let token = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null
if (token) {
this.getAccessToken()
} else {
this.getAfterLogin().then(() => {
this.$store.dispatch('userInfoAction', this.userInfo)
this.getflowProcedure()

this.getCurrentDate()
this.getDataList()

})
}

this.getNotice()
},
methods: {
...mapActions(['currentProcedureInfoAction']),

getAccessToken () {
let token = JSON.stringify(getRequest(window.location.href)) !== '{}' ? getRequest(window.location.href).info : null
if (token) {
this.$store.dispatch('LoginAction', token)
this.getAfterLogin().then(() => {
this.$store.dispatch('userInfoAction', this.userInfo)
this.getflowProcedure()

this.getDataList()

})
this.$vux.toast.text('登录成功', 'top')
} else {
if (!this.token) {
this.$vux.toast.text('未通过移动泰山科技学院获取到学生身份', 'top')
}
}
},

back () {

Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app'])
},
toLogin () {
setTimeout(() => {
this.$router.push({'name': 'login'})
}, 300)
},
getAfterLogin () {
return new Promise((resolve, reject) => {
this.$api.get('/user/afterLogin', null,
r => {
if (r.data.flowBean) {
this.flowInfo = {
flowId: r.data.flowBean.id,
flowType: r.data.flowBean.flowType,
flowYear: r.data.flowBean.year
}
this.$store.dispatch('flowInfoAction', this.flowInfo)
} else {
this.$vux.alert.show({
title: '当前时间您不在办理流程中',
content: '请于流程开始后再访问',
onShow () {
},
onHide () {

Cordova.exec(null, null, 'SYNPlugin', 'synCordovaPlugin', ['synjones.synpay.window.exit.app'])
}
})
}
this.userInfo = r.data.studentBean

this.$set(this.userInfo, 'studentPictureUrl', r.data.studentPictureUrl)
this.$store.dispatch('flowInfoAction', this.flowInfo)
resolve()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
})
},
getflowProcedure () {

let params = {
flowId: this.flowId
}
this.$api.get('/flowProcedure', params,
r => {

let data = r.data
let idArr = []
data.forEach(element => {
let obj = {
procedureId: element.procedureBean.id,
flowProcedureId: element.id,
name: element.procedureBean.name,
startDate: element.startDate,
endDate: element.endDate,
status: element.procedureBean.status,
icon: element.procedureBean.icon,
flag: element.procedureBean.flag,
router: element.procedureBean.router,
flagFlow: element.flag,
config: element.config
}

idArr.push(element.procedureBean.id)
this.flowProcedureList2.push(obj)
})
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
getDataList () {
this.$vux.loading.show()
let params = {
studentId: this.studentId,
flowId: this.flowId,
'flowBean.isInFlow': 1
}
this.$api.get('/dataManagement/getDataManagementList', params,
r => {
let data = r.data
let arr1 = []
let arr2 = []
data.forEach(element => {
this.dataList.push(element)
if (element.status !== 4) {
arr1.push(element)
} else {
arr2.push(element)
}
})
this.dataList2 = arr1.concat(arr2)
this.$vux.loading.hide()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
getNotice () {

let params = {
isQueryContent: 1,
isExpire: 1,
isPublish: 1
}
this.$api.get('/notice', params,
r => {
this.$vux.loading.hide()
let data = r.data.slice(0, 2)
data.forEach(element => {
let obj = {
title: element.title
}
this.noticeList.push(obj)
})
if (this.noticeList.length > 0) {
this.isBadge = true
} else {
this.isBadge = false
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

getCurrentDate () {
return new Promise((resolve, reject) => {
this.$api.get('/helper/systemDateTime', null, r => {

this.currentDate = r.data
resolve()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
})
},

getIsOverdue (endDate, procedureBeanId, router, name) {

if (Date.parse(endDate + ' 23:59:59') < Date.parse(this.currentDate)) {
this.getManageState(endDate, procedureBeanId, router, name)
} else {
this.getPreposition(procedureBeanId, router, name)
}
},

getPreposition (procedureBeanId, router, name) {
let params = {
'procedureBean.id': procedureBeanId,
'studentBean.id': this.studentId,
'flowBean.id': this.flowId
}
this.$api.get('/dataManagement', params, r => {
this.$vux.loading.hide()
if (r.data.status === 4 || r.data.status === 1 || r.data.status === 3 || r.data.status === 6) {
this.$router.push({name: 'itemResult', params: { title: name, status: r.data.status }})
} else {
this.$router.push({name: router, params: { title: name, status: r.data.status }})
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

getManageState (endDate, procedureBeanId, router, name) {
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': procedureBeanId
}
this.$api.get('/dataManagement/getDataManagementList', params, r => {
this.$vux.loading.hide()
if (r.data.length > 0) {
if (r.data[0].status === 4 || r.data[0].status === 1 || r.data[0].status === 3 || r.data[0].status === 6) {
this.$router.push({name: 'itemResult', params: { title: name, status: r.data.status }})
} else {
this.$vux.toast.text('该手续已于' + endDate + '结束办理', 'middle')
}
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},
currentProcedure (item) {

let itemDate = item.flowProcedureBean.startDate
this.getCurrentDate().then(() => {
if (this.token && (DatetimeStamp(itemDate + ' 00:00:00') <= DatetimeStamp(this.currentDate))) {
let currentProcedureInfo = {
flowProcedureId: item.flowProcedureId,
procedureId: item.procedureId,
name: item.procedureBean.name,
router: item.procedureBean.router,
endDate: item.flowProcedureBean.endDate,

parentRouter: 'home'
}
this.$store.dispatch('currentProcedureInfoAction', currentProcedureInfo)
if (item.procedureBean.flag.split('')[0] === '1' && item.procedureBean.flag.split('')[1] === '0') {
this.$vux.toast.text(item.procedureBean.name + '需到现场办理，不可网上办理', 'middle')
} else if (item.flowProcedureBean.flag.split('')[5] === '1' && item.procedureId !== 3) {
window.location = item.flowProcedureBean.config











} else {
if (item.procedureBean.router === 'pay' || item.procedureBean.router === 'info') {
this.$router.push({
name: item.procedureBean.router,
query: {
flowProcedureId: item.flowProcedureId,
procedureId: item.procedureId
}
})
} else {
this.getIsOverdue(item.flowProcedureBean.endDate, item.procedureId, item.procedureBean.router, item.procedureBean.name)
}
}
} else if (!this.token) {
this.toLogin()
} else if (DatetimeStamp(itemDate + ' 00:00:00') > DatetimeStamp(this.currentDate)) {
this.$vux.alert.show({
title: item.procedureBean.name + '未到办理时间',
content: '请于' + itemDate + '办理',
buttonText: '我知道了'
})
}
})
},
isDonate () {
let params = {
studentId: this.studentId,
flowId: this.flowId
}
return new Promise((resolve, reject) => {
this.$api.get('/donation', params,
r => {
if (r.data.length > 0) {
this.donateFlag = false
} else {
this.donateFlag = true
}
resolve()
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/home.vue